/**
 * Component Registry for Woodview at Randolph
 * 
 * Inherits from @vibesites-dolben/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dolben/theme-rise/registry';
import { FloorPlansPopup } from './components/FloorPlansPopup';
import { Gallery } from './components/Gallery';
import { Header } from './components/Header';
import { ModernApartmentFeatures } from './components/ModernApartmentFeatures';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FloorPlansPopup,
  Gallery,
  Header,
  ModernApartmentFeatures,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
